"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-damiano-d-asti": {
    "4b17e41e": [{
      "hkey": "da86f980",
      "slug": "martinetta",
      "name": "Martinetta",
      "primary": true,
      "skipSearch": false
    }],
    "castelnuovo-martinetta": [{
      "hkey": "da86f980",
      "slug": "martinetta",
      "name": "Martinetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "67748265": [{
      "hkey": "ee39a0a0",
      "slug": "san-damiano-d-asti",
      "name": "San Damiano d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "serra-di-costa": [{
      "hkey": "ee39a0a0",
      "slug": "san-damiano-d-asti",
      "name": "San Damiano d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4193418": [{
      "hkey": "ee39a0a0",
      "slug": "san-damiano-d-asti",
      "name": "San Damiano d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "valdoisa": [{
      "hkey": "ee39a0a0",
      "slug": "san-damiano-d-asti",
      "name": "San Damiano d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a839754e": [{
      "hkey": "78e99b01",
      "slug": "valzeglio",
      "name": "Valzeglio",
      "primary": true,
      "skipSearch": false
    }],
    "verzeglio": [{
      "hkey": "78e99b01",
      "slug": "valzeglio",
      "name": "Valzeglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;